<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="3500"
          :reset="true"
          :expand-adv="true"
          :show-simple="false"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>isAdvancedQuery=value"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="primary"
              @click="accrueHandler"
            >{{ this.$t('CargoMsg.Cargo_Accrue') }}
            </el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="25000621"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </div>
    </div>
    <accrue-select-dialog
      v-if="accrueSelectDialog.visible"
      ref="accrueSelectDialog"
      :visible.sync="accrueSelectDialog.visible"
      @accrueSelect="accrueSelectHandler"
    />

    <!--    查看关联业务-->
    <show-job-dialog
      v-if="showJobDialog.visible"
      ref="showJobDialog"
      :visible.sync="showJobDialog.visible"
      :jobs="showJobDialog.jobs"
      @close="showJobDialog.visible = false"
    />

  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AccrueSelectDialog from '@/views/cargo/v0/Performance/tabPane/accrueSelectDialog.vue'
import { advancedQuery } from '@/api/ruleConfig/ruleConfigAi'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage } from '@/utils/commonUtil'
import {
  advancedQueryProvisionFunc,
  checkAccrueFunc,
  confirmProvisionFunc,
  queryJobDataByUuidsFunc
} from '@/api/ruleConfig/provisionReport'
import $store from '@/store'
import ShowJobDialog from '@/views/cargo/v0/Performance/tabPane/showJobDialog.vue'

export default {
  name: 'PendingProvision',
  components: {
    ShowJobDialog,
    AccrueSelectDialog,
    searchItem
  },
  data() {
    return {
      URL,
      isAdvancedQuery: true, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      filter: {
        conditions: [],
        pageNum: 1,
        pageSize: 10000
      },
      accrueSelectDialog: {
        visible: false
      },
      showJobDialog: {
        visible: false,
        jobs: []
      },
      ruleConfigs: [],
      filterJson: {},
      selectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Message.Name2'),
          colId: 'userId',
          field: 'userId',
          width: 150,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Post'),
          colId: 'commissionRole',
          field: 'commissionRole',
          width: 150,
          cellRenderer: (params) => {
            return CommonState.getNameByCode(SystemConstants.COMMISSION_ROLE_LIST, params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessVolume'),
          colId: 'businessNum',
          field: 'businessNum',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableRule'),
          colId: 'applicableScriptUuid',
          field: 'applicableScriptUuid',
          width: 150,
          cellRenderer: (params) => {
            if (this.ruleConfigs && this.ruleConfigs.length > 0 && params.data.applicableScriptUuid) {
              const ruleC = this.ruleConfigs.filter(p => p.uuid === params.data.applicableScriptUuid)
              if (ruleC && ruleC.length > 0) {
                return ruleC[0].scriptName
              }
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CommissionAmount'),
          colId: 'commissionAmount',
          field: 'commissionAmount',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ViewDetailedBusiness'),
          field: 'dateCreated',
          width: 200,
          cellRenderer: params => {
            if (params.data.businessNum) {
              const onViewDetailedBusiness = this.documentManage.getPath('onViewDetailedBusiness')
              return `<button><div onclick="${onViewDetailedBusiness}('${params.data.jobs}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_View')}</div></button>`
            } else {
              return ''
            }
          }
        }
      ],
      rowData: [],
      documentManage: new DocumentManage()
    }
  },
  computed: {},
  beforeMount() {
    setTimeout(() => {
      this.init()
    }, 0)
    const context = this
    this.documentManage.set('onViewDetailedBusiness', function(value) {
      context.onViewDetailedBusiness(value)
    })
  },
  methods: {
    async init() {
      this.ruleConfigs = []
      const from = {}
      from.branchId = this.$store.getters.currentOfficeId
      advancedQuery(from).then(res => {
        this.ruleConfigs = res.data.list
      })
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = data
        // 高级查询条件组装
        this.filter.conditions = [...data]
        this.filter.pageNum = 1
      }
      // 至少选择一组过滤条件
      if (!this.filter.conditions || this.filter.conditions.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSALOGODC2'))
        return
      }
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      advancedQueryProvisionFunc(this.filterJson).then((res) => {
        this.rowData = res.data
        this.fullscreenLoading.close()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    onViewDetailedBusiness(jobs) {
      if (jobs && jobs.length !== 0) {
        const uuids = jobs.split(',')
        queryJobDataByUuidsFunc({ branchId: $store.getters.currentOfficeId, keys: uuids }).then(res => {
          this.showJobDialog.jobs = res.data
          this.showJobDialog.visible = true
        })
      }
    },
    // 计提
    accrueHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      checkAccrueFunc({ branchId: $store.getters.currentOfficeId, vos: rows }).then(res => {
        if (res.data) {
          this.$message.warning(this.$t('CargoMsg.Cargo_UsersAlreadyProvisionedToday'))
        } else {
          this.accrueSelectDialog.visible = true
        }
      })
    },
    // 确认计提
    accrueSelectHandler(e) {
      if (e) {
        const rows = this.gridOptions.api.getSelectedRows()
        const data = {
          branchId: $store.getters.currentOfficeId,
          customsProvision: e.customsProvision,
          opProvision: e.opProvision,
          opTicketProvision: e.opTicketProvision,
          csProvision: e.csProvision,
          businessProvision: e.businessProvision,
          salesProvision: e.salesProvision,
          lockCharge: e.lockCharge,
          vos: rows
        }
        confirmProvisionFunc(data).then(res => {
          this.toAdvancedQuery()
          this.$message.success(this.$t('CargoMsg.Cargo_Accrue') + this.$t('CargoMsg.Cargo_Success'))
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      }
    }
  }
}
</script>
